import rangeBg from "assets/images/rangeBg.svg";

export const images = {
  rangeBg,
};
